import { DatadogLoggingService } from '@edx/frontend-logging';

/**
 * Custom implementation of DatadogLoggingService.
 *
 * @extends DatadogLoggingService
 */
class CustomDatadogLoggingService extends DatadogLoggingService {
  getAllowedTracingUrls() {
    const baseAllowedTracingUrls = super.getAllowedTracingUrls();
    const services = [
      { name: 'enterprise-access' },
    ];
    const additionalAllowedTracingUrls = services.map(({ name, ...serviceOpts }) => {
      const serviceUrl = `https://${name}.stage.edx.org`;
      if (Object.keys(serviceOpts).length > 0) {
        return {
          match: serviceUrl,
          ...serviceOpts,
        };
      }
      return serviceUrl;
    });
    return [
      ...baseAllowedTracingUrls,
      ...additionalAllowedTracingUrls,
    ];
  }
}

const config = {
  loggingService: CustomDatadogLoggingService,
};

export default config;
